import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/69802719921dc90014f0aa38/website_project/node_modules/next/dist/client/app-dir/link.js");
